import {useCallback} from 'react';

export const useNativeRedirect = () => {
    const redirect = useCallback(
        (link: string) => () => {
            if (link) {
                window.location.href = link;
            }
        },
        []
    );

    return {
        redirect,
    };
};
